module.exports = __webpack_public_path__ + "img/yi7.7de2c45c.jpg";